<template>
  <div class="row">
    <h1>{{ $t('views.dashboard.title') }}</h1>
    <loading-container :state="state">
      <ul class="row list-unstyled mx-auto p-inline-start-0">

        <li v-if="labelAdminUrl && isAdmin" class="col-12">
          <a :href="sanitizeUrl(labelAdminUrl)" class="h1 d-flex align-items-center no-underline">
            <span class="icon icon-datei_word mr-2" aria-hidden="true"></span>
            <span class="title title-with-icon"> {{ $t('views.dashboard.editLabels') }}</span>
          </a>
        </li>

        <li class="col-12 mb-3" v-if="isAdmin">
          <router-link to="/rooms" class="h1 d-flex align-items-center no-underline">
            <span class="icon icon-alle mr-2" aria-hidden="true"></span>
            <span class="title title-with-icon"> {{ $t('views.dashboard.editRoomsAndReservations') }}</span>
          </router-link>
        </li>
        <li class="col-12 mb-3">
          <router-link to="/reservations" class="h1 d-flex flex-wrap align-items-center no-underline">
            <span class="icon icon-produkte_formulare mr-2" aria-hidden="true"></span>
            <div>
              <span class="title title-with-icon"> {{ $t('views.dashboard.reservationsList') }}</span>
            </div>
          </router-link>
        </li>
        <li class="col-12 mb-3" v-if="isAdmin">
          <router-link to="/overbooked" class="h1 d-flex flex-wrap align-items-start no-underline">
            <span class="icon icon-vorteile_rund_um_die_uhr mr-2" aria-hidden="true"></span>
            <div>
              <span class="title title-with-icon"> {{ $t('views.dashboard.overbooked') }}</span>
              <div class="break"></div>
              <span v-if="overbookedTimeSlots.length > 0" class="invalid-feedback d-block font-16">{{ $tc('common.overbookedTimeSlots', overbookedTimeSlots.length ) }}</span>
            </div>
          </router-link>
        </li>
        <li class="col-12 mb-3" v-if="isAdmin">
          <router-link to="/blacklist" class="h1 d-flex align-items-center no-underline">
            <span class="icon icon-alert_fehler mr-2" aria-hidden="true"></span>
            <span class="title title-with-icon"> {{ $t('views.dashboard.blacklist') }}</span>
          </router-link>
        </li>
        <li class="col-12 mb-3" v-if="isAdmin">
          <router-link to="/holiday-list" class="h1 d-flex align-items-center no-underline">
            <span class="icon icon-schliesszeiten mr-2" aria-hidden="true"></span>
            <span class="title title-with-icon"> {{ $t('views.dashboard.holidayList') }}</span>
          </router-link>
        </li>
        <li class="col-12 mb-3">
          <router-link to="/reports" class="h1 d-flex align-items-center no-underline">
            <span class="icon icon-produkte_statistik mr-2" aria-hidden="true"></span>
            <span class="title title-with-icon"> {{ $t('views.dashboard.reports') }}</span>
          </router-link>
        </li>
      </ul>
    </loading-container>
  </div>
</template>

<script lang="ts">
import LoadingContainer from '@/components/structure/LoadingContainer.vue';
import config from '@/config/config';
import { TimeSlot } from '@/generated/openapi';
import LoadingMixin from '@/mixins/LoadingMixin';
import { GuiOptions } from '@/models/GuiOptions';
import { adminService } from '@/services/adminService';
import { LoadingState } from '@/utils/loadingUtils';
import { defineComponent } from 'vue';
import { urlService } from '@/services/urlService';

export default defineComponent({
  name: 'Dashboard',
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      labelAdminUrl: config.labelAdminUrl,
      isAdmin: config.interface === GuiOptions.admin,
      overbookedTimeSlots: [] as TimeSlot[]
    }
  },
  components: {
    LoadingContainer
  },
  created() {
    if (this.isAdmin) {
      adminService.findOverbookedTimeSlots().then(timeSlots => {
        this.overbookedTimeSlots = timeSlots
      this.state = LoadingState.success
      }).catch(this.handleErrorWithI18nString)
    } else {
      this.state = LoadingState.success
    }
  },
  methods: {
    sanitizeUrl(url: string) {
      return urlService.sanitizeThisUrl(url)
    }
  }
});
</script>
